
window.copyToClipboard = function(text) {
    navigator.clipboard.writeText(text);
};

window.shareMessageWhatsapp = function(text) {
    const urlTemplate = 'https://wa.me/?text=';
    window.open(urlTemplate + text, '_blank').focus();
};

window.shareMessageTelegram = function(text, url) {
    window.open('https://telegram.me/share/url?url=' + url + '&text=' + text, '_blank').focus();
};
